<script>
import { onMount } from 'svelte';
import dataLayer from 'nespresso-library/src/core/dataLayer'
import apiData from "api-client"

export let link = "#";
export let role = "button";
export let action = "";
export let trackingLabel = "";
export let screenName = "";
export let className = undefined;
export let dataPopinId = undefined;
export let closeText = "";
export let label = "";

checkLink();

async function checkLink(){
  if(link === "nespresso://preferredPLP"){
    try{
      var res = await Promise.all([
        apiData.hasVertuo(),
        apiData.preferredTechnoOriginal()
      ])
    }catch(e){
      console.log("Cta - getData Error - ",e)
    }
    const hasVertuo = res[0];
    const preferredTechnoOriginal = res[1];
    const baseUrl = 'https://www.nespresso.com/'+dataLayer.country.toLowerCase()+'/'+dataLayer.language.toLowerCase();
    if(hasVertuo){
      if(preferredTechnoOriginal){
        link = baseUrl + '/order/capsules/original';
      }else{
        link = baseUrl + '/order/capsules/vertuo';
      }
    }else{
      link = baseUrl + '/order/capsules';
    }
  }
}

function trackAction(){
  if (!!window.gtmDataObject) {
    const tracking = {
      event: 'promoClick',
      eventRaisedBy: 'Casper Component Provider',
      ecommerce: {
        promoClick: {
          promotions: [{
            id: 'loyalty_banner',
            name: 'Loyalty Banner',
            creative: 'banner - screen '+screenName,
            position: 'click button - '+trackingLabel
          }]
        }
      }
    }
    window.gtmDataObject.push(tracking);
  }
}

function openLogin(){
  if (document.getElementById("ta-login-dropdown--not-logged")) {
    document.getElementById("ta-login-dropdown--not-logged").click();
  }
}

function openChat(){
  if (!!window.dydu && !!window.dydu.chatbox) {
    window.dydu.chatbox.togglePopin(true);
  }else if(window.calleoChat){
    window.calleoChat("startChat")
  }
}

function onClick(e) {
  switch(action){
    case "trigger-login" :
      openLogin();
      break;
    case "trigger-chat" :
      openChat();
      break;
    case "trigger-popin" :
      openLightbox();
      e.preventDefault();
      break;
    default :
    break;
  }
  trackAction();
  if(link === "#" || link === ""){
    //if link is empty, it must be equal to # to prevent navigating to current Url (refreshing)
    //href attribute being mandatory
    link = "#";
    e.preventDefault();
    e.stopPropagation();
  }
}

function openLightbox(){
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  const doc = document.documentElement;
  const scrollY = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
  const w = window.innerWidth;
  const h = window.innerHeight;
  let popinWidth,popinHeight;
  //768 for ipad
  if(w < 768){
    popinWidth = w;
    popinHeight = h;
    const popin = document.getElementById('creditPopin');
    popin.classList.add('mobile');
  }else{
    popinWidth = 739;
    popinHeight = 'auto';
  }
  document.documentElement.classList.add('g_scrollLock');
  window.$(link).removeAttr('style');
  window.$(link).dialog({
    modal: true,
    closeText: closeText,
    dialogClass: 'creditPopinContainer dark ui-popin',
    title: '',
    width: popinWidth,
    height: popinHeight,
    resizable: false,
    closeOnEscape: true,
    draggable: false,
    clickOutside: true,
    show: {
      effect: "fadeIn",
      duration: 300
    },
    hide: {
      effect: "fadeOut",
      duration: 300
    },
    open: function() {
      window.$(".loyaltyClosePopin").on("click", function(e) {
        window.$(link).dialog("close");
      });
      window.$(".ui-widget-overlay").on("click", function() {
        window.$(link).dialog("close");
      }).addClass("dark-overlay");
    },
    close: function() {
      window.$(".loyaltyClosePopin").off("click");
      document.documentElement.classList.remove('g_scrollLock');
      window.$(".ui-widget-overlay").removeClass("dark-overlay");
      setTimeout(()=>{
        //ugly IE11 hack because hovers are broken after closing dialog
        if(isIE11){
          document.documentElement.style.display = "";
          setTimeout(()=>{
            document.documentElement.style.display = "block";
          },20);
        }
        setTimeout(function () {
          window.scrollTo(0,scrollY);
        }, 20);
      },20);
    }
  });
}
</script>

<a
  class={'cta ' + role + (className ? ' '+className : '')}
  class:ctaLogin={action === "trigger-login"}
  data-popin-id={dataPopinId}
  href={link}
  target={action === 'external-link' ? '_blank' : null}
  rel={action === 'external-link' ? 'noopener' : null}
  on:click={onClick}>
  {#if role === 'button'}
    <span class="label">
      {@html label}
    </span>
  {:else}
    {@html label}
  {/if}
</a>

<style>
  .cta {
    text-align: center;
    cursor: pointer;
    color: inherit;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    justify-content: center;
    position: relative;
    margin: 0 23px 0 0;
    transition: color 0.4s, background-color 0.4s, border-color 0.4s;
  }
  .cta * {
    pointer-events: none;
  }
  .cta.popin-trigger {
    position: relative;
    z-index: 10;
  }
  .cta.popin-trigger:before {
    content: "";
    position: absolute;
    left: 0;
    top: -12px;
    width: 100%;
    height: 40px;
  }
  .link {
    border: none;
    text-decoration: underline;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 1px;
    line-height: 24px;
    padding-top: 3px;
  }
  .link:hover {
    text-decoration: none;
  }
  .button.ctaLogin {
    border-color: #8F7247 !important;
    background-color: #8F7247 !important;
  }
  .button.ctaLogin:hover {
    color: #8F7247 !important;
    background-color: #fff !important;
  }
  .button {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 22px;
    text-decoration: none;
    text-transform: uppercase;
    border-radius: 4px;
    background-color: #3D8705;
    border-color: #3D8705;
    border-style: solid;
    border-width: 2px;
    user-select: none;
    text-align: center;
    min-width: 134px;
    padding: 8px 14px 6px 14px;
  }
  .button:hover {
    color: #3D8705;
    background-color: #fff;
    border-style: solid;
    border-width: 2px;
    border-color: #3D8705;
  }
  .label {
    display: inline-block;
    position: relative;
    background-color: transparent;
  }
  @media (max-width: 768px) {
    .cta:not(.ctaLeft){
      display: table;
      margin: 0 auto;
    }
    .link {
      font-size: 14px;
      padding-top: 13px;
    }
  }
  :global(.g_scrollLock body){
    height: 100vh;
    overflow-y: hidden;
  }
</style>
